import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useBizLogicActions, useVerify } from 'stores';

const AuthBannerWithDate = () => {
	const { t } = useTranslation();
	const verify = useVerify();
	const { getAuthBannerDate } = useBizLogicActions();
	const status = verify?.status;
	const scanData = verify?.scanData;
	const authBannerDate = getAuthBannerDate(scanData);

	if (!verify) return <></>;

	if (!status || status === 'verify') return <></>;

	if (!scanData || !authBannerDate) return <></>;

	if (
		[
			'msg_code_recalled_fail',
			'msg_code_single_success',
			'msg_code_single_ordinary',
		].indexOf(verify.code) !== -1
	)
		return <></>;

	return (
		<>
			<Stack
				direction="row"
				spacing={1}
				pl={2}
				pr={2}
				alignItems="center"
			>
				{status === 'success' && (
					<VerifiedUserIcon
						sx={{
							width: '25px',
							height: '25px',
							color: 'authenticated.main',
						}}
					/>
				)}
				{status === 'failed' && (
					<GppMaybeIcon
						sx={{
							width: '25px',
							height: '25px',
							color: 'error.main',
						}}
					/>
				)}
				<Typography fontSize="12px" color="defaultText.main">
					{t(
						`verify.authBannerDate${process.env.REACT_APP_AUTHBANNERDATE_MODE}`
					)}
					{authBannerDate}
				</Typography>
			</Stack>
		</>
	);
};

export default AuthBannerWithDate;
